/* Pawvela sale price display. Shows a crossed-out price only when Shopify has a real
   regular price above the selling price. Loaded after pawvela.js.
   Flash sales (product metafields pawvela.flash_was, pawvela.flash_end, pawvela.flash_end_at)
   also get a live countdown banner on the product page, a "Flash sale" line, and the
   crossed-out price on the homepage card. The countdown runs to the real end time and
   never resets; at zero it says the sale has ended. */
(function () {
  var CSS = '' +
    '.pv-flash{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin:6px 0 14px;padding:12px 16px;border-radius:14px;background:#C8341C;color:#fff;box-shadow:0 6px 18px rgba(200,52,28,.28)}' +
    '.pv-flash__lbl{display:flex;align-items:center;gap:8px;font-weight:800;font-size:15px;letter-spacing:.01em}' +
    '.pv-flash__dot{width:10px;height:10px;border-radius:50%;background:#fff;animation:pvPulse 1.2s ease-in-out infinite}' +
    '.pv-flash__t{display:flex;gap:6px;margin-left:auto;font-variant-numeric:tabular-nums}' +
    '.pv-flash__u{display:flex;flex-direction:column;align-items:center;min-width:46px;padding:5px 6px;border-radius:9px;background:rgba(255,255,255,.16)}' +
    '.pv-flash__u b{font-size:21px;line-height:1;font-weight:800}' +
    '.pv-flash__u small{font-size:10.5px;opacity:.9;margin-top:3px}' +
    '.pv-flash__sub{flex-basis:100%;font-size:13.5px;opacity:.95}' +
    '.pv-flash.is-over{background:#4A5566;box-shadow:none}' +
    '.pv-flash.is-over .pv-flash__dot{animation:none;opacity:.5}' +
    '.pv-sticky .pv-flash-mini{color:#C8341C;font-weight:800}' +
    '@keyframes pvPulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.35;transform:scale(.7)}}' +
    '@media (max-width:420px){.pv-flash__t{margin-left:0}}' +
    '@media (prefers-reduced-motion:reduce){.pv-flash__dot{animation:none}}';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function countdown(pdp, p, v, pct) {
    var PV = window.PV;
    var end = Date.parse(p.flash_end_at); if (!end || isNaN(end)) return;
    if (!document.getElementById('pv-flash-css')) { var st = document.createElement('style'); st.id = 'pv-flash-css'; st.textContent = CSS; document.head.appendChild(st); }
    var box = pdp.querySelector('.pv-flash');
    if (!box) {
      var pl = pdp.querySelector('.pv-priceline'); if (!pl) return;
      box = document.createElement('div'); box.className = 'pv-flash'; box.setAttribute('role', 'timer'); box.setAttribute('aria-live', 'off');
      box.innerHTML = '<span class="pv-flash__lbl"><span class="pv-flash__dot" aria-hidden="true"></span><span data-l>Flash sale ends in</span></span>' +
        '<span class="pv-flash__t"><span class="pv-flash__u"><b data-h>00</b><small>hours</small></span><span class="pv-flash__u"><b data-m>00</b><small>min</small></span><span class="pv-flash__u"><b data-s>00</b><small>sec</small></span></span>' +
        '<span class="pv-flash__sub" data-sub></span>';
      pl.insertAdjacentElement('beforebegin', box);
    }
    var h = box.querySelector('[data-h]'), m = box.querySelector('[data-m]'), s = box.querySelector('[data-s]');
    box.querySelector('[data-sub]').textContent = 'Save ' + pct + '% today. The price goes back to ' + PV.money(v.compare) + ' when the timer hits zero.';
    var timer;
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left === 0) {
        box.classList.add('is-over'); box.querySelector('[data-l]').textContent = 'This flash sale has ended';
        box.querySelector('.pv-flash__t').hidden = true; box.querySelector('[data-sub]').textContent = 'Refresh the page to see the current price.';
        if (timer) clearInterval(timer); return;
      }
      var sec = Math.floor(left / 1000);
      h.textContent = pad(Math.floor(sec / 3600)); m.textContent = pad(Math.floor(sec % 3600 / 60)); s.textContent = pad(sec % 60);
    }
    tick(); timer = setInterval(tick, 1000);
  }

  function flash() {
    var PV = window.PV; if (!PV || !PV.product) return;
    var seen = {};
    Array.prototype.forEach.call(document.querySelectorAll('script[data-pv-product]'), function (node) {
      var h = node.getAttribute('data-pv-product'); if (seen[h]) return; seen[h] = true;
      var p = PV.product(h); if (!p || !p.flash_end) return;
      var v = p.variants.slice().sort(function (a, b) { return a.price - b.price; })[0];
      if (!v || !(v.compare > v.price)) return;
      if (p.flash_end_at && Date.parse(p.flash_end_at) <= Date.now()) return;
      var pct = Math.floor((v.compare - v.price) * 100 / v.compare);
      var txt = 'Flash sale · save ' + pct + '% · ends ' + p.flash_end;
      var pdp = document.getElementById('pv-pdp');
      if (pdp && pdp.dataset.handle === h) {
        var line = pdp.querySelector('.pv-saleline');
        if (line) { line.textContent = txt; }
        else {
          var pl = pdp.querySelector('.pv-priceline');
          if (pl) { line = document.createElement('p'); line.className = 'pv-saleline'; line.textContent = txt; pl.insertAdjacentElement('afterend', line); }
        }
        if (p.flash_end_at) countdown(pdp, p, v, pct);
      }
      Array.prototype.forEach.call(document.querySelectorAll('.pv-card h3 a[href$="/products/' + h + '"]'), function (a) {
        var card = a.closest('.pv-card'); if (!card) return;
        var pr = card.querySelector('.pv-price');
        if (pr) pr.innerHTML = (PV.hasRange && PV.hasRange(p) ? '<small>From </small>' : '') + '<s class="pv-was">' + PV.money(v.compare) + '</s> ' + PV.money(v.price) + '<span class="pv-save">Save ' + pct + '% · ends ' + p.flash_end + '</span>';
        var ph = card.querySelector('.pv-card__ph');
        if (ph && !ph.querySelector('.pv-tag--sale')) { var t = document.createElement('span'); t.className = 'pv-tag pv-tag--sale'; t.textContent = 'Flash sale'; ph.appendChild(t); }
      });
      if (h === 'expandable-travel-carrier') {
        var sp = document.querySelector('[data-pv-spotprice]');
        if (sp && PV.priceHTML) sp.innerHTML = PV.priceHTML(v);
      }
    });
  }
  function boot() {
    var PV = window.PV; if (!PV || PV.priceHTML) return;
    PV.priceHTML = function (v) {
      if (v.compare && v.compare > v.price) {
        return '<s class="pv-was">' + PV.money(v.compare) + '</s> ' + PV.money(v.price) + ' <span class="pv-save">Save ' + Math.floor((v.compare - v.price) * 100 / v.compare) + '%</span>';
      }
      return PV.money(v.price);
    };
    PV.fromHTML = function (p) {
      var cheapest = p.variants.slice().sort(function (a, b) { return a.price - b.price; })[0];
      return (PV.hasRange(p) ? 'From ' : '') + PV.priceHTML(cheapest);
    };
    var open = PV.openSheet;
    PV.openSheet = function (handle, opts) {
      open(handle, opts);
      var p = PV.product(handle), b = document.getElementById('pv-sheet-b'); if (!p || !b) return;
      var sp = b.querySelector('[data-sp]'); if (sp) sp.innerHTML = PV.fromHTML(p);
      Array.prototype.forEach.call(b.querySelectorAll('input[type=radio]'), function (r) {
        r.addEventListener('change', function () {
          var choice = p.options.map(function (o, i) {
            var c = b.querySelector('fieldset[data-opt="' + i + '"] input:checked'); return c ? c.value : null;
          });
          var v = PV.resolve(p, choice); if (v && sp) sp.innerHTML = PV.priceHTML(v);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', flash); else flash();
  }
  if (window.PV) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
